export default __webpack_public_path__ + "static/media/ph.83f1de56.svg";